import { Outlet } from "react-router";
import SideNavBar from "./SideNavBar";
import { useState } from "react";

const WithSideNavBar = () => {
  const [open, setOpen] = useState(true);

  return (
    <div style={{ display: "flex" }}>
      <SideNavBar title="Menu" open={open} setOpen={setOpen} />
      <div style={{ flexGrow: 1, position: "relative", marginTop: "2rem" }}>
        <Outlet />
        </div>
    </div>
  );
};

export default WithSideNavBar;
